import Vue from 'vue'
let vueBus = new Vue()
export default vueBus
